import { Injectable, inject } from '@angular/core';
import type { NormCubicMeter } from '@clean-code/models';
import type {
  DataTableParameters,
  PagingResponse,
} from '@clean-code/models/common';
import { GraphqlService } from '@clean-code/shared/util-graphql';
import type { EditSearchDataService } from '@clean-code/shared/util/util-data-service';
import type { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NormCubicMeterService
  implements EditSearchDataService<NormCubicMeter>
{
  private graphqlService: GraphqlService = inject(GraphqlService);

  private entityFields = `
      id
      year
      factor
      updatedDate
      updatedBy
      updatedByDec{
        fullName
      }
    `;

  public getAll$(
    params: DataTableParameters,
  ): Observable<PagingResponse<NormCubicMeter>> {
    return this.graphqlService.getAll(
      params,
      'loadProfileNormCubicMeterSettingGetAll',
      this.entityFields,
    );
  }

  public getById$(id: string): Observable<NormCubicMeter> {
    return this.graphqlService.getById(
      id,
      'loadProfileNormCubicMeterSettingGetById',
      this.entityFields,
    );
  }

  public add$(
    loadProfileNormCubicMeterSetting: NormCubicMeter,
  ): Observable<boolean> {
    const input = {
      year: loadProfileNormCubicMeterSetting.year,
      factor: loadProfileNormCubicMeterSetting.factor,
    };

    const mutation = `
        mutation ($input: AddLoadProfileNormCubicMeterSettingInput!){
          addLoadProfileNormCubicMeterSetting(input: $input)
        }`;

    return this.graphqlService.query<boolean>(mutation, { input });
  }

  public update$(loadProfileNormCubicMeterSetting: NormCubicMeter) {
    const input = {
      id: +loadProfileNormCubicMeterSetting.id,
      year: loadProfileNormCubicMeterSetting.year,
      factor: loadProfileNormCubicMeterSetting.factor,
    };

    const mutation = `
        mutation ($input: UpdateLoadProfileNormCubicMeterSettingInput!){
          updateLoadProfileNormCubicMeterSetting(input: $input)
        }`;

    return this.graphqlService.query<boolean>(mutation, { input });
  }

  public delete$(id: string) {
    const mutation = `
    mutation ($id: Int!){
      deleteLoadProfileNormCubicMeterSetting(id: $id)
      }`;

    return this.graphqlService.mutation<boolean>(mutation, { id });
  }
}
